class relatedInvoiceCtrl {
    constructor($scope, httpRequest, $state, initSortService) {
        function init() {
            $scope.storageName = 'goodsStaRelInvParam'
            const storageParam = localStorage.goodsStatisticsRelatedInvoice ? JSON.parse(localStorage.goodsStatisticsRelatedInvoice) : {}
            $scope.queryParam = sessionStorage[$scope.storageName] ? JSON.parse(sessionStorage[$scope.storageName]) : {
                orderMap: {},
                pageNum: 1,
                pageSize: 10,
                param: {
                    beginTime: storageParam.param.beginTime,
                    endTime: storageParam.param.endTime,
                    orgId: storageParam.param.orgId,
                    matName: storageParam.goods.matName,
                    revenueName: storageParam.goods.revenueName,
                    spec: storageParam.goods.spec,
                    unit: storageParam.goods.unit,
                },
            }
            $scope.orderMap = initSortService($scope.storageName)
        }
        init()

        function getDictArr() {
            httpRequest.get_dictByTypeArr(['ivat_orig_inv_type', 'ovat_tax_rate']).then((res) => {
                $scope.dictData = res.data.value
            })
        }
        getDictArr()

        function queryInvoiceList() {
            httpRequest.post_qryGoodsRelationInvoiceList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
            })
        }
        queryInvoiceList()

        $scope.pageChanged = function pageChanged() {
            sessionStorage.setItem($scope.storageName, JSON.stringify($scope.queryParam))
            queryInvoiceList()
        }

        $scope.selectedHandle = function selectedHandle() {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem($scope.storageName, JSON.stringify($scope.queryParam))
            queryInvoiceList()
        }

        $scope.$on('$stateChangeStart', (e, toState) => {
            if (toState.name.indexOf('statistics.inputStatistics.goodsStatistics.relatedInvoice') == -1) {
                sessionStorage.removeItem($scope.storageName)
            }
        })

        $scope.toInvoiceDetail = function toInvDetail(item) {
            const url = $state.href(
                'statistics.inputStatistics.goodsStatistics.relatedInvoiceDetail', {
                    object: JSON.stringify({
                        invoiceCode: item.invoiceCode,
                        invoiceNumber: item.invoiceNumber,
                    }),
                }, {
                    reload: true,
                },
            )
            window.open(url, '_blank')
        }
    }
}
relatedInvoiceCtrl.$inject = ['$scope', 'httpRequest', '$state', 'initSortService']
export default relatedInvoiceCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/goodsStatistics/relatedInvoiceCtrl.js